import axios from 'axios'
import {AUTH_REFRESH_DATA} from '../../mutations'

export const REFERRAL_ACCEPT = 'REFERRAL_ACCEPT'
export const REFERRAL_LOOKUP = 'REFERRAL_LOOKUP'
export const REFERRAL_SET = 'REFERRAL_SET'
export const REFERRAL_SET_LIST = 'DATA_SET_REFERRALS'
export const REFERRAL_FETCH_LIST = 'REFERRAL_FETCH_LIST'

const state = {
    referral: null, // {code: null, company: null},
    referrals: []
}

const getters = {
    getReferralCode: state => state.referral ? state.referral.code : null,
    getReferralCompany: state => state.referral ? state.referral.company : null,
    getReferrals: state => state.referrals || []
}

export const actions = {
    [REFERRAL_FETCH_LIST]: ({commit}) => {
        return new Promise((resolve, reject) => {
            axios.get('teams/referrals')
                .then(resp => {
                    commit(REFERRAL_SET_LIST, resp.data.data)
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    [REFERRAL_LOOKUP]: ({commit, dispatch}, code) => {
        return new Promise((resolve, reject) => {
            axios.post(`referral/lookup/${code}`)
                .then(res => {
                    commit(REFERRAL_SET, res.data)
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    [REFERRAL_ACCEPT]: ({commit, dispatch}, code) => {
        return new Promise((resolve, reject) => {
            axios.post(`referral/accept/${code}`)
                .then(() => {
                    commit(REFERRAL_SET, null)
                    return dispatch(AUTH_REFRESH_DATA)
                })
                .then((res) => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}

export const mutations = {
    [REFERRAL_SET]: (state, rsp) => {
        state.referral = rsp
    },
    [REFERRAL_SET_LIST]: (state, data) => {
        state.referrals = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
